import router from './router'

import useSuperSdk from '@/assets/js/useSuperSdk.js'

router.beforeEach(async (to, from, next) => {
    
  const { getSuperID } = useSuperSdk()

  const userInfo = await getSuperID()

  localStorage.setItem('openId', userInfo.openId)

  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})
